import gql from 'graphql-tag';

export default gql`
  mutation UpdateUser(
    $id: ID!
    $firstName: String
    $lastName: String
    $email: String
    $password: String
    $role: UserRole
    $status: UserStatus
    $image: FileUpdateInput
    $authCode: String
  ) {
    updateUser(
      data: {
        firstName: $firstName
        lastName: $lastName
        email: $email
        password: $password
        role: $role
        status: $status
        image: $image
        authCode: $authCode
      }
    id: $id
    ) {
      createdAt
      updatedAt
      id
      firstName
      lastName
      email
      password
      otp
      status
      role
      authCode
      image {
        id
        original
        scaled
        thumbnail
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/UpdateUser.ts